// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import { getAnalyticsMetadataAttribute } from '@cloudscape-design/component-toolkit/internal/analytics-metadata';
import InternalAlert from '../alert/internal';
import InternalBox from '../box/internal';
import { BuiltInErrorBoundary } from '../error-boundary/internal';
import { useInternalI18n } from '../i18n/context';
import { getBaseProps } from '../internal/base-component';
import InternalLiveRegion from '../live-region/internal';
import analyticsSelectors from './analytics-metadata/styles.css.js';
import styles from './styles.css.js';
export default function InternalForm({ children, header, errorText, errorIconAriaLabel: errorIconAriaLabelOverride, actions, secondaryActions, __internalRootRef, __injectAnalyticsComponentMetadata, __errorSlotId, ...props }) {
    const baseProps = getBaseProps(props);
    const i18n = useInternalI18n('form');
    const errorIconAriaLabel = i18n('errorIconAriaLabel', errorIconAriaLabelOverride);
    const analyticsComponentMetadata = {
        component: {
            name: 'awsui.Form',
            label: {
                selector: ['h1', 'h2', 'h3'].map(heading => `.${analyticsSelectors.header} ${heading}`),
            },
        },
    };
    return (
    // We suppress nested error boundaries so that if there is an unexpected error inside the form - the entire form
    // will be replaced with a fallback message. That is to ensure that no part of the form can crash without the user
    // noticing that, as then a part of the form data might not get submitted.
    React.createElement(BuiltInErrorBoundary, { suppressNested: true },
        React.createElement("div", { ...baseProps, ref: __internalRootRef, className: clsx(styles.root, analyticsSelectors.root, baseProps.className), ...(__injectAnalyticsComponentMetadata ? getAnalyticsMetadataAttribute(analyticsComponentMetadata) : {}) },
            header && React.createElement("div", { className: clsx(styles.header, analyticsSelectors.header) }, header),
            children && React.createElement("div", { className: styles.content }, children),
            errorText && (React.createElement(InternalBox, { margin: { top: 'l' } },
                React.createElement(InternalAlert, { type: "error", statusIconAriaLabel: errorIconAriaLabel },
                    React.createElement("div", { className: styles.error, id: __errorSlotId }, errorText)))),
            (actions || secondaryActions) && (React.createElement("div", { className: styles.footer },
                React.createElement("div", { className: styles['actions-section'] },
                    actions && React.createElement("div", { className: styles.actions }, actions),
                    secondaryActions && React.createElement("div", { className: styles['secondary-actions'] }, secondaryActions)))),
            errorText && (React.createElement(InternalLiveRegion, { hidden: true, tagName: "span", assertive: true },
                errorIconAriaLabel,
                ", ",
                errorText)))));
}
//# sourceMappingURL=internal.js.map